/* Generated file. Do not modify. Please check more details in build/generate.ts */
import * as React from "react";
import type { IconProps } from "../IconTypes";
import { IconWrapper } from "../IconWrapper";
export function EqualsIcon(props: IconProps) {
    return (<IconWrapper {...props}>
            {<path d="M11.154 13h17.692c.625 0 1.154.688 1.154 1.5 0 .875-.529 1.5-1.154 1.5H11.154C10.48 16 10 15.375 10 14.5c0-.812.48-1.5 1.154-1.5m0 11h17.692c.625 0 1.154.688 1.154 1.5 0 .875-.529 1.5-1.154 1.5H11.154C10.48 27 10 26.375 10 25.5c0-.812.48-1.5 1.154-1.5"/>}
        </IconWrapper>);
}
